import { render, staticRenderFns } from "./turningMaterials.vue?vue&type=template&id=0ab0a252&scoped=true"
import script from "./turningMaterials.vue?vue&type=script&lang=js"
export * from "./turningMaterials.vue?vue&type=script&lang=js"
import style0 from "./turningMaterials.vue?vue&type=style&index=0&id=0ab0a252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0a252",
  null
  
)

export default component.exports